<template>
  <div class="page">
    <!-- header -->
    <header-bar :selected="selected" :cityName="cityName" @getCityId="getCityId"></header-bar>
    <!-- banner -->
    <div class="banner-wrapper" v-if="mid!=undefined">
      <div class="banner">
        <!-- 海报 -->
        <div class="banner-l">
          <div class="avatar-shadow"><img :src=filmDetail.pic></div>
        </div>
        <!-- 详情 -->
        <div class="banner-r">
          <div class="info">
            <div class="name">{{filmDetail.title}}</div>
            <div class="score">{{filmDetail.scores}}</div>
            <ul>
              <li> {{filmDetail.category}} </li>
              <li v-if="filmDetail.duration!=''">{{filmDetail.duration}}分钟</li>
              <li>{{filmDetail.releaseDate}} {{filmDetail.country}}</li>
            </ul>
            <div :class="['desc', zhankai?'':'active']">
              剧情介绍：{{filmDetail.summary}}
              <span class="zhankai" @click="openDesc" v-if="zhankai==false" >展开>></span>
              <span class="heqi" @click="closeDesc" v-else>收起<<</span>
            </div>
          </div>
        </div>
        <!-- 剧照 -->
        <div class="banner-inside">
          <div class="photos" @click="toWholeImg">
            <img :src=tlinkList0>
            <span v-if="filmDetail.tlinkList != null">{{filmDetail.tlinkList.length}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- container -->
    <div class="container">
      <!-- 搜索区 -->
      <div class="tags-panel">
        <div class="tags-lines">
          <!-- 日期 -->
          <!-- <div class="tags-line date"  v-if="mid!=undefined">
            <div class="tags-title">日期：</div>
            <ul class="tags">
              <li :class="[brandTag=='index'?'active':'']" v-for="(item, index) in 9">今天1月8</li>
            </ul> 
          </div>-->
          <!-- 品牌 -->
          <!-- <div class="tags-line brand">
            <div class="tags-title">品牌：</div>
            <ul class="tags">
              <li :class="[brandTag==''?'active':'']">全部</li>
              <li :class="[brandTag=='index'?'active':'']" v-for="(item, index) in 55">万达影城</li>
            </ul>
          </div> -->
          <!-- 行政区 -->
          <div class="tags-line">
            <div class="tags-title">行政区：</div>
            <ul class="tags">
              <li :class="[areaTag=='-1'?'active':'']" @click="searchArea('', '-1')">全部</li>
              <li :class="[areaTag==index?'active':'']" v-for="(item, index) in areaList" :key="index"
               @click="searchArea(item.id, index)">{{item.name}}</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- list -->
      <div class="cinemas-list">
        <h2 class="cinemas-list-header">
          <span>影院列表</span>
        </h2>
        <div class="cinema-cell" v-for="item in cinemaList">
          <div class="cinema-info">
            <div class="cinema-name" @click="toCinemaDetail(item.cid)">{{item.name}}</div>
            <div class="cinema-address">地址：{{item.address}}</div>
            <div class="cinema-tags">
              <span class="cinema-tags-item" v-if="(item.saleType==0 || item.saleType == 1)">在线选座</span>
              <span class="cinema-tags-item" v-if="(item.saleType==0 || item.saleType == 2)">线下刷卡</span>
            </div>
          </div>
          <div class="buy-btn">
            <span class="btn" @click="toCinemaDetail(item.cid)">选座购票</span>
          </div>
          <div class="price">
            <span class="rmb" v-if="item.cinema_money!=0"></span>
            <span class="num" v-if="item.cinema_money!=0">{{item.cinema_money}}</span>
            <span v-if="item.cinema_money!=0">起</span>
            <span class="cinema-distance">{{item.distance}}</span>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          layout="total,prev, pager, next"
          :page-size="pageSize"
          :current-page.sync="pageNum"
          :total="total">
        </el-pagination>
        </div>
    </div>
    <!-- footer -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
  import headerBar from '@/components/headerBar'
  import footerBar from '@/components/footerBar'
  import {getCinemaList} from '@/api/cinema'
  import {getFilmDetail, cityPosit} from '@/api/film'

  export default {
    components: {headerBar, footerBar},
    data(){
      return{
        // 参数--影片id
        mid: this.$route.query.mid,
        // 是否展开剧情介绍
        zhankai: false,
        // 选中的当前导航
        selected: "2",
        // 品牌tag
        brandTag: "",
        // 行政区tag
        areaTag: "-1",
        // 城市id
        cityId: '',
        // 城市名称
        cityName: '',
        // 维度
        latitude: '',
        // 精度
        longitude: '',
        // 区域id
        areaId: 0,
        // 行政区列表
        areaList: [],
        // 影片信息
        filmDetail: {},
        // 影片第一张剧照
        tlinkList0: "",
        // 影院数据
        cinemaList: [],
        // 分页
        pageNum: 1,
        pageSize: 12,
        total: 0,
      }
    },
    mounted() {
      //保证this实例已经插入文档
      this.$nextTick(function(){
        // 切换页面时滚动条自动滚动到顶部
        window.scrollTo(0,0);
        // 获取本地存储城市
        this.cityId = localStorage.getItem('cityId');
        this.cityName = localStorage.getItem('cityName');
        this.latitude = localStorage.getItem('latitude');
        if(this.latitude == null){
            this.latitude = "";
        }
        this.longitude = localStorage.getItem('longitude');
        if(this.longitude == null){
            this.longitude = "";
        }
        // 获取影片数据
        if(this.mid){
          this.getFilmDetail();
        }
        // 获取影院列表数据
        this.getCinemaList();
      })
    },
    methods: {
      // 获取子组件（headerBar）传递的值
      getCityId(cityId){
        this.cityId = cityId;
        this.pageNum = 1;
        // 行政区tag
        this.areaTag = "-1";
        // 区域id
        this.areaId = "";
        // 获取影片数据
        if(this.mid){
          this.getFilmDetail();
        }
        // 获取影院列表数据
        this.getCinemaList();
      },
      // 获取影片数据
      getFilmDetail() {
      	let signdata = {mid: this.mid, cityId: this.cityId};
        let data = {mid: this.mid, cityId: this.cityId, signdata: signdata};
        getFilmDetail(data).then(response => {
          this.filmDetail = response.data;
          if(response.data.tlinkList.length > 0){
            this.tlinkList0 = response.data.tlinkList[0];
          }
        });
      },
      // 获取影院列表数据
      getCinemaList() {
        let signdata = {cityId: this.cityId, areaid: this.areaId, saleType: '0', latitude: this.latitude, longitude: this.longitude, page: this.pageNum};
        let data = {cityPosId: this.cityId, cityId: this.cityId, areaid: this.areaId, saleType: '0', latitude: this.latitude, longitude: this.longitude, page: this.pageNum, pageSize: this.pageSize, signdata: signdata};
        //影片详情
        if(this.mid){
          signdata = {mid: this.mid, cityId: this.cityId, areaid: this.areaId, saleType: '0', latitude: this.latitude, longitude: this.longitude, page: this.pageNum};
          data = {mid: this.mid, cityPosId: this.cityId, cityId: this.cityId, areaid: this.areaId, saleType: '0', latitude: this.latitude, longitude: this.longitude, page: this.pageNum, pageSize: this.pageSize, signdata: signdata};
        }
        getCinemaList(data).then(response => {
          this.areaList = response.data.areaList;
          this.cinemaList = response.data.cinemaList;
          this.total = response.total;
        });
      },
      // 点击行政区搜索影院
      searchArea(id, index){
        this.pageNum = 1;
        this.areaTag = index;
        this.areaId = id;
        let signdata = {cityId: this.cityId, areaid: id, saleType: '0', latitude: this.latitude, longitude: this.longitude, page: 1};
        let data = {cityPosId: this.cityId, cityId: this.cityId, areaid: id, saleType: '0', latitude: this.latitude, longitude: this.longitude, page: 1, pageSize: this.pageSize, signdata: signdata};
        getCinemaList(data).then(response => {
          this.areaList = response.data.areaList;
          this.cinemaList = response.data.cinemaList;
          this.total = response.total;
        });
      },
      // 展开剧情介绍
      openDesc(){
        this.zhankai = true;
      },
      // 收起剧情介绍
      closeDesc(){
        this.zhankai = false;
      },
      // 跳转到影院详情
      toCinemaDetail(cid){
        this.$router.push({path: '/show', query: {cid: cid, mid: this.mid}})
      },
      // 跳转到剧照
      toWholeImg(){
        // 打开新窗口
        let routeData = this.$router.resolve({ path: '/wholeImg', query: {mid: this.mid}});
        window.open(routeData.href, '_blank');
        // this.$router.push({path: '/wholeImg', query: {mid: this.mid}})
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getCinemaList();
        // 切换页面时滚动条自动滚动到顶部
        window.scrollTo(0,0);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*banner*/
  .banner-wrapper{
    margin-top: 80px;
    width: 100%;
    background: url('../assets/images/film-detail-bg.png') repeat 50%;
  }
  .banner{
    display: flex;
    position: relative;
    margin: 0 auto;
    width: 75%;
    height: 376px;
  }
  .banner .banner-l {
    position: relative;
    top: 70px;
    z-index: 9;
    width: 300px;
    overflow: hidden;
  }
  .banner .banner-l .avatar-shadow {
    position: relative;
    margin: 0 30px;
    width: 240px;
    height: 330px;
    padding-bottom: 40px;
    background: url('../assets/images/film-detail-img-b.png') no-repeat bottom;
  }
  .banner .banner-l .avatar-shadow img{
    display: block;
    border: 4px solid #fff;
    height: 322px;
    width: 232px;
  }
  .banner .banner-r {
    flex: 1;
    position: relative;
    margin-right: 30px;
    margin-top: 70px;
    text-align: left;
  }
  .banner .banner-r .info {
    position: absolute;
    z-index: 1;
    color: #fff;
    font-size: 14px;
  }
  .banner .banner-r .info .name{
    display: -webkit-box;
    margin-top: 0;
    margin-bottom: 0;
    /*width: 900px;*/
    max-height: 64px;
    line-height: 32px;
    font-size: 26px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .banner .banner-r .info .score{
    margin-top: 12px;
    font-size: 30px;
    color: #ffc600;
  }
  .banner .info ul {
    width: 250px;
    list-style: none;
    padding-left: 0;
  }
  .banner .info ul li {
    margin: 12px 0;
    line-height: 100%;
  }
  .banner .info .desc{
    margin-top: 12px;
  }
  .banner .desc{
    position: relative;
    height: auto;
    max-height: 124px;
    line-height: 1.5;
    transition: height .2s ease;
    overflow: hidden;
  }
  .banner .desc.active{
    height: 40px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .banner .desc .zhankai{
    float: right;
    position: absolute;
    right: 0;
    bottom: -2px;
    z-index: 10;
    width: 5em;
    color: #eb002a;
    background: #3a305a;
  }
  .banner .desc .heqi{
    position: absolute;
    right: 0;
    margin-bottom: 0;
    width: 5em;
    color: #eb002a;
    background: #3a305a;
  }
  /*剧照*/
  .banner .banner-inside{
    margin-top: 10%;
    width: 156px;
    text-align: center;
  }
  .banner .banner-inside .photos{
    width: 100%;
    cursor: pointer;
  }
  .banner .banner-inside .photos img{
    display: block;
    width: 156px;
    height: 100px;
  }
  .banner .banner-inside .photos span{
    transform: translateY(-10px);
    display: inline-block;
    width: 20px;
    height: 20px;
    background: rgba(0,0,0,.5);
    text-align: center;
    line-height: 20px;
    color: #fff;
  }
  .container {
    margin-top: 100px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 30px;
    width: 75%;
  }
  /*搜索区*/
  .tags-panel {
    position: relative;
    margin: 40px 0;
    padding: 0 20px;
    border: 1px solid #e5e5e5;
  }
  .tags-line {
    padding: 10px 0;
  }
  .tags-line.date{
    border-bottom: 1px dashed #e5e5e5;
  }
  .tags-line.brand{
    border-bottom: 1px dashed #e5e5e5;
  }
  .tags-title {
    float: left;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #999;
  }
  .tags-panel .tags {
    margin-left: 40px;
    text-align: left;
  }
  .tags li {
    display: inline-block;
    margin-left: 12px;
    padding: 3px 9px;
    border-radius: 14px;
    color: #333;
    font-size: 14px;
  }
  .tags li:hover{
    color: #f34d41;
    cursor: pointer;
  }
  .tags li.active {
    background: #f34d41;
    color: #fff;
  }
  .cinemas-list .cinemas-list-header {
    position: relative;
    margin: 0;
    padding-left: 6px;
    line-height: 18px;
    font-size: 18px;
    color: #333;
    text-align: left;
    border-left: 4px solid #f03d37;
  }
  h2 {
    font-weight: bold;
  }
  .cinemas-list .cinema-cell {
    display: block;
    padding: 20px 0;
    text-align: left;
    border-bottom: 1px dashed #e5e5e5;
  }
  .cinemas-list .cinema-info {
    display: inline-block;
    max-width: 80%;
  }
  .cinemas-list .cinema-name {
    display: inline-block;
    margin-bottom: 10px;
    line-height: 18px;
    font-size: 16px;
    color: #333;
  }
  .cinemas-list .cinema-name:hover{
    color: red;
    cursor: pointer;
  }
  .cinemas-list .cinema-address {
    line-height: 14px;
    font-size: 14px;
    color: #999;
  }
  .cinemas-list .cinema-tags {
    margin-top: 10px;
    line-height: 18px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #509fc9;
  }
  .cinemas-list .cinema-tags span.cinema-tags-item {
    display: inline-block;
    margin-right: 8px;
    padding: 0 2px;
    border: .7px solid #509fc9;
    border-radius: 3px;
  }
  .cinemas-list .buy-btn {
    float: right;
    margin-top: 7px;
    margin-left: 36px;
    margin-right: 20px;
    width: 80px;
    height: 45px;
    line-height: 45px;
    text-align: center;
  }
  .cinemas-list .btn {
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    background-color: #f03d37;
    font-size: 14px;
    border-radius: 100px;
    box-shadow: 0 2px 10px -2px #f03d37;
    cursor: pointer;
  }
  .cinemas-list .price {
    float: right;
    height: 45px;
    line-height: 45px;
    font-size: 12px;
    color: #999;
  }
  .cinemas-list .price .rmb {
    margin-right: -4px;
    color: #f03d37;
  }
  .cinemas-list .price .num {
    margin-right: -3px;
    font-size: 16px;
    font-weight: 700;
    color: #f03d37;
  }
  .cinemas-list .cinema-distance {
    display: block;
    margin-top: -8px;
    height: 17px;
    line-height: 17px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999;
    letter-spacing: 0;
    text-align: right;
  }
  /*分页*/
  .pagination-container{
    margin-top: 30px;
    /*margin-bottom: 62px;*/
  }
</style>


// WEBPACK FOOTER //
// src/views/cinemaList.vue